<kendo-dialog [title]="titulo" (close)="accion('cerrar')" [minWidth]="250" [width]="450" [maxHeight]="300">
        <div class="NotST" *ngFor="let item of notificaciones">{{ item }}</div> 
    <kendo-dialog-actions>
        <button kendoButton (click)="accion('aceptar')" class="k-button">Aceptar</button>
    </kendo-dialog-actions>
</kendo-dialog>

